import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { v4 as uuid } from 'uuid';

/**
 * Generates an effectively unique ID
 */
export function shortUUID() {
  return uuid().replace(/-/g, '');
}